<div class="dialog-agent">
  <h1 mat-dialog-title>{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.COMPLETE' | translate }}</h1>
  <div mat-dialog-content class="">
    <div class="row m-0">
      <div class="col-12">
        {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.COMPLETE-DETAILS' | translate }}
      </div>
      <div *ngIf="data.pinMode !== 'NoPIN'" class="col-12 py-2">
        <!-- pin -->
        <mat-label class="w-100 d-block fw-bold">
          <span *ngIf="data.pinMode === 'CertPIN'">
            {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.INSERT-PIN' | translate }}
          </span>
          <span *ngIf="data.pinMode === 'UserPIN'">
            {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.INSERT-USERPIN' | translate }}
          </span>
        </mat-label>
        <mat-form-field *ngIf="data.pinMode === 'CertPIN'" class="w-100">
          <input matInput [placeholder]="'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.INTRODUCE-PIN' | translate" [type]="hide ? 'password' : 'text'" #toPin="ngModel" [(ngModel)]="result.pin" required autocomplete="new-password">
          <i class="rt-icon pointer fs22 mx-2" matSuffix [attr.data-selenium]="'toggle-cert-pin'" (click)="hide = !hide" [ngClass]="{'rt-view': hide, 'rt-hide': !hide}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="toPin.errors && toPin.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
        <mat-form-field *ngIf="data.pinMode === 'UserPIN'" class="w-100">
          <input matInput [placeholder]="'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.INTRODUCE-USERPIN' | translate" [type]="hide ? 'password' : 'text'" #toPin="ngModel" [(ngModel)]="result.pin" required autocomplete="new-password">
          <i class="rt-icon pointer fs22 mx-2" matSuffix [attr.data-selenium]="'toggle-cert-pin'" (click)="hide = !hide" [ngClass]="{'rt-view': hide, 'rt-hide': !hide}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="toPin.errors && toPin.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
        <mat-form-field *ngIf="data.pinMode === 'BothPINs'" class="w-100">
          <input matInput [placeholder]="'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.INTRODUCE-BOTHPIN' | translate" [type]="hide ? 'password' : 'text'" #toPin="ngModel" [(ngModel)]="result.pin" required autocomplete="new-password">
          <i class="rt-icon pointer fs22 mx-2" matSuffix [attr.data-selenium]="'toggle-cert-pin'" (click)="hide = !hide" [ngClass]="{'rt-view': hide, 'rt-hide': !hide}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="toPin.errors && toPin.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
      </div>
      <div *ngIf="data.needReason" class="col-12 py-2">
        <!-- reason -->
        <mat-label class="w-100 d-block fw-bold">
          {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.INSERT-REASON' | translate }}
        </mat-label>
        <mat-form-field class="w-100">
          <textarea matInput [placeholder]="'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CHECK-PIN-DIALOG.INTRODUCE-REASON' | translate" #toReason="ngModel" [(ngModel)]="result.reason" [ngModelOptions]="{standalone: true}" required autocomplete="new-password" [attr.data-selenium]="'toggle-cert-reason'"></textarea>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="toReason.errors && toReason.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" [disabled]="loader || ((data.pinMode !== 'NoPIN') && (!result.pin?.trim() || result.pin?.length < 4)) ||(data.needReason && !result.reason?.trim())" class="ms-2 float-end" (click)="checkPin()">
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile && !loader"></i>
      <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="loader"></i>
      <span *ngIf="!isMobile && !loader">{{ 'GLOBAL.SIGN' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" [disabled]="loader" class="" (click)="onCancel()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
